const Footer = () => {
    return <footer>
        <div className="footer-text">&#169; 2025 Computable Publishing LLC</div>
    </footer>;
}

export default Footer;